import axios from 'axios';

const api = axios.create({
    baseURL: '/admin/goals/'
});

export const getBranchGoal = (user_id) => api.get(`branch-goal/${user_id}`);
export const getPersonalGoal = (user_id) => api.get(`personal-goal/${user_id}`);
export const getStudentsNationality = (user_id) => api.get(`students-nationality/${user_id}`);
export const getBranches = () => api.get(`branches`);
export const getBranchGoals = () => api.get(`branch-goals`);
export const createBranchGoal = (payload) => api.post(`branch-goal`, payload);
export const updateBranchGoal = (goal_id, payload) => api.put(`branch-goals/${goal_id}`, payload);
export const deleteBranchGoal = (goal_id) => api.delete(`branch-goals/${goal_id}`);
export const getUsers = (role_id) => api.get(`${role_id}/users`);
export const getPersonalGoals = (role_id) => api.get(`${role_id}/personal-goals`);
export const createPersonalGoal = (payload) => api.post(`personal-goal`, payload);
export const updatePersonalGoal = (goal_id, payload) => api.put(`personal-goals/${goal_id}`, payload);
export const deletePersonalGoal = (goal_id) => api.delete(`personal-goals/${goal_id}`);

export const getSalesRank = (params) => api.get(`sales-rank`, { params });